export interface PropertyListing {
  id: string;
  slug: string;
  title: string;
  description: string;
  category: 'event-centre' | 'hotel' | 'apartment' | 'office' | 'restaurant';
  city: 'abuja' | 'lagos' | 'jos' | 'port-harcourt';
  location: string;
  price: string;
  priceType: 'per-day' | 'per-night' | 'per-month' | 'per-event';
  imageUrl: string;
  tourUrl: string;
  videoUrl?: string;
  videoPosterUrl?: string;
  amenities: string[];
  rating: number;
  reviewCount: number;
  featured: boolean;
  capacity?: string;
  size?: string;
  coordinates?: { lat: number; lng: number };
  beaconNumber?: string;
  verified?: boolean;
  captureDate?: string;
  architectFirm?: string;
  galleryImages?: string[];
  galleryPreviewImages?: string[];
  isLive?: boolean;
}

// Category-specific Kuula/Momento360 public tour URLs
// Real public Kuula & Momento360 embeddable tour URLs by category
const TOUR_URLS = {
  eventCentre1: "https://kuula.co/embed/collection/79sT0",
  eventCentre2: "https://kuula.co/embed/collection/79sT0",
  hotel1: "https://momento360.com/e/u/d7ba5959f84b4e2a90cf61cb1e0691e6?utm_campaign=embed&utm_source=other&heading=0&pitch=0&field-of-view=75",
  hotel2: "https://momento360.com/e/u/d7ba5959f84b4e2a90cf61cb1e0691e6?utm_campaign=embed&utm_source=other&heading=0&pitch=0&field-of-view=75",
  hotel3: "https://momento360.com/e/u/d7ba5959f84b4e2a90cf61cb1e0691e6?utm_campaign=embed&utm_source=other&heading=0&pitch=0&field-of-view=75",
  apartment1: "https://kuula.co/embed/collection/79sT0",
  apartment2: "https://kuula.co/embed/collection/79sT0",
  office1: "https://kuula.co/embed/collection/79sT0",
  restaurant1: "https://kuula.co/embed/collection/79sT0",
  amsterdamBar: "https://kuula.co/share/collection/7Mfnz",
  asokoroResidence: "https://kuula.co/share/collection/7MvBQ",
  asokoroEstate7_5: "https://kuula.co/share/collection/7Mcwn",
};

export const sampleListings: PropertyListing[] = [
  {
    id: "asokoro-9br",
    slug: "asokoro-9br-ultra-luxury-residence",
    title: "9BR Ultra-Luxury Residence",
    description: "An architectural statement in one of Abuja's most prestigious enclaves. Sitting on ~1,000sqm, this fully finished 9-bedroom residence offers exceptional scale, privacy and refined detailing — ideal for diplomatic or ultra-high-net-worth occupancy. Basement cinema/gym, penthouse suite, private pool.",
    category: "apartment",
    city: "abuja",
    location: "Asokoro – Navy Town / Admiralty Estate, Abuja",
    price: "₦2,500,000,000",
    priceType: "per-event",
    imageUrl: "https://bezrjptjrwryyhkmgwcp.supabase.co/storage/v1/object/public/tour-images/asokoro-9br.jpg",
    tourUrl: TOUR_URLS.asokoroResidence,
    amenities: ["9 En-Suite Bedrooms", "Private Pool", "Penthouse Suite", "Finished Basement", "Gated Estate", "Secure Parking"],
    rating: 5.0,
    reviewCount: 1,
    featured: false,
    capacity: "Private Residence",
    size: "1,000 sqm",
    coordinates: { lat: 9.0401, lng: 7.5174 },
    verified: true,
    isLive: true,
    captureDate: "2026-02-10",
    galleryImages: [
      "https://images.unsplash.com/photo-1613977257363-707ba9348227?w=800&q=80",
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&q=80",
      "https://images.unsplash.com/photo-1600607688969-a5bfcd646154?w=800&q=80",
    ],
  },
  {
    id: "asokoro-estate-7-5b",
    slug: "asokoro-estate-7-5b-capture",
    title: "Ultra-Luxury Estate – 8 Units of 7BR Duplexes",
    description: "An exceptional opportunity to acquire a premium gated residential estate in the heart of Asokoro, Abuja's most prestigious district. Eight (8) units of fully detached 7-bedroom duplexes, each with basement level, situated on 5,000 sqm of prime land within a secure gated community. Fully fitted interiors with modern kitchens, AC systems, and ample parking. Ideal for diplomatic housing, corporate residential quarters, or high-end rental income.",
    category: "apartment",
    city: "abuja",
    location: "Asokoro, Abuja",
    price: "₦8,000,000,000",
    priceType: "per-event",
    imageUrl: "https://bezrjptjrwryyhkmgwcp.supabase.co/storage/v1/object/public/tour-images/asokoro-estate-entrance.jpg",
    tourUrl: TOUR_URLS.asokoroEstate7_5,
    videoUrl: "/videos/asokoro-estate-7-5b.mp4",
    videoPosterUrl: "/videos/asokoro-estate-7-5b-poster.jpg",
    amenities: ["8 Detached 7BR Duplexes", "Basement Levels", "5,000 sqm Land", "Gated Community", "Fitted Kitchens", "AC Systems", "Ample Parking"],
    rating: 5.0,
    reviewCount: 1,
    featured: true,
    capacity: "Private Residence",
    size: "Not specified",
    coordinates: { lat: 9.0401, lng: 7.5174 },
    verified: true,
    isLive: true,
    captureDate: "2026-03-14",
    galleryImages: [
      "/images/asokoro-estate/kuula-01.jpg",
      "/images/asokoro-estate/kuula-02.jpg",
      "/images/asokoro-estate/kuula-03.jpg",
      "/images/asokoro-estate/kuula-04.jpg",
      "/images/asokoro-estate/kuula-05.jpg",
      "/images/asokoro-estate/kuula-06.jpg",
      "/images/asokoro-estate/kuula-07.jpg",
      "/images/asokoro-estate/kuula-08.jpg",
      "/images/asokoro-estate/kuula-09.jpg",
      "/images/asokoro-estate/kuula-10.jpg",
      "/images/asokoro-estate/kuula-11.jpg",
      "/images/asokoro-estate/kuula-12.jpg",
      "/images/asokoro-estate/kuula-13.jpg",
      "/images/asokoro-estate/kuula-14.jpg",
      "/images/asokoro-estate/kuula-15.jpg",
      "/images/asokoro-estate/kuula-16.jpg",
      "/images/asokoro-estate/kuula-17.jpg",
      "/images/asokoro-estate/kuula-18.jpg",
      "/images/asokoro-estate/kuula-19.jpg",
      "/images/asokoro-estate/kuula-20.jpg",
      "/images/asokoro-estate/kuula-21.jpg",
      "/images/asokoro-estate/kuula-22.jpg",
      "/images/asokoro-estate/kuula-23.jpg",
      "/images/asokoro-estate/kuula-24.jpg",
      "/images/asokoro-estate/kuula-25.jpg",
      "/images/asokoro-estate/kuula-26.jpg",
      "/images/asokoro-estate/kuula-27.jpg",
      "/images/asokoro-estate/kuula-28.jpg",
      "/images/asokoro-estate/kuula-29.jpg",
      "/images/asokoro-estate/kuula-30.jpg",
      "/images/asokoro-estate/kuula-31.jpg",
      "/images/asokoro-estate/kuula-32.jpg",
      "/images/asokoro-estate/kuula-33.jpg",
      "/images/asokoro-estate/kuula-34.jpg",
      "/images/asokoro-estate/kuula-35.jpg",
      "/images/asokoro-estate/kuula-36.jpg",
    ],
    galleryPreviewImages: [
      "/images/asokoro-estate/kuula-01.jpg",
      "/images/asokoro-estate/kuula-02.jpg",
      "/images/asokoro-estate/kuula-03.jpg",
      "/images/asokoro-estate/kuula-04.jpg",
      "/images/asokoro-estate/kuula-05.jpg",
      "/images/asokoro-estate/kuula-06.jpg",
      "/images/asokoro-estate/kuula-07.jpg",
      "/images/asokoro-estate/kuula-08.jpg",
      "/images/asokoro-estate/kuula-09.jpg",
      "/images/asokoro-estate/kuula-10.jpg",
      "/images/asokoro-estate/kuula-11.jpg",
      "/images/asokoro-estate/kuula-12.jpg",
    ],
  },
  {
    id: "0",
    slug: "amsterdam-bar-grills",
    title: "Amsterdam Bar & Grills",
    description: "Experience premium outdoor dining at its finest. Amsterdam Bar & Grills offers an exquisite ambiance, signature cocktails, and international cuisine in the heart of Garki. Perfect for business lunches, casual gatherings, and evening celebrations.",
    category: "restaurant",
    city: "abuja",
    location: "Garki, Abuja",
    price: "₦450,000",
    priceType: "per-event",
    imageUrl: "https://bezrjptjrwryyhkmgwcp.supabase.co/storage/v1/object/public/tour-images/amsterdam-bar.jpg",
    tourUrl: TOUR_URLS.amsterdamBar,
    amenities: ["Outdoor Seating", "360° Virtual Tour", "Full Bar Service", "International Cuisine", "Event Hosting", "Premium Ambiance"],
    rating: 4.9,
    reviewCount: 184,
    featured: false,
    isLive: true,
    capacity: "200 guests",
    size: "650 sqm",
    coordinates: { lat: 9.0579, lng: 7.4951 },
    verified: true,
    captureDate: "2026-02-15",
    galleryImages: [
      "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&q=80",
      "https://images.unsplash.com/photo-1559339352-11d3b4bcc013?w=800&q=80",
      "https://images.unsplash.com/photo-1585518419759-47ac0b1f19f8?w=800&q=80",
    ],
  },
  {
    id: "1",
    slug: "prestige-event-centre",
    title: "Prestige Event Centre",
    description: "A stunning 500-capacity event centre in the heart of Garki. Perfect for weddings, conferences, and corporate events. Features state-of-the-art sound systems and elegant chandeliers.",
    category: "event-centre",
    city: "abuja",
    location: "Garki Area 11, Abuja",
    price: "₦850,000",
    priceType: "per-event",
    imageUrl: "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?w=800&q=80",
    tourUrl: TOUR_URLS.eventCentre1,
    amenities: ["500 Capacity", "Air Conditioning", "Sound System", "Parking", "Catering Kitchen", "Bridal Suite"],
    rating: 4.9,
    reviewCount: 127,
    featured: true,
    capacity: "500 guests",
    size: "2,500 sqm",
    coordinates: { lat: 9.0579, lng: 7.4951 },
    beaconNumber: "FCT/ABJ/GK/2024/0451",
    verified: true,
    captureDate: "2026-01-15",
    galleryImages: [
      "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?w=800&q=80",
      "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=800&q=80",
      "https://images.unsplash.com/photo-1431540015161-0bf868a2d407?w=800&q=80",
      "https://images.unsplash.com/photo-1505236858219-8359eb29e329?w=800&q=80",
    ],
  },
  {
    id: "12",
    slug: "bellagio-boutique-event-venue",
    title: "Bellagio Boutique Event Venue (Matterport)",
    description: "High-end event venue showcase with elegant lobby, bar, and bridal salon. Use this placeholder to demo a Matterport embedded tour.",
    category: "event-centre",
    city: "abuja",
    location: "Sample City",
    price: "Contact for pricing",
    priceType: "per-event",
    imageUrl: "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?w=800&q=80",
    tourUrl: "https://my.matterport.com/show/?m=EXAMPLE",
    amenities: ["10,000+ sq ft", "Bridal Salon", "Private Bar", "Fiber Optic Ceiling", "Modern Lighting"],
    rating: 4.8,
    reviewCount: 68,
    featured: false,
    capacity: "400 guests",
    size: "3,200 sqm",
    verified: false,
    captureDate: "2025-11-01",
  },
  {
    id: "13",
    slug: "berlin-event-locations",
    title: "Berlin Event Locations Directory",
    description: "Browse multiple venues with 360° Tour badges. Great for showing a directory-style listing of event spaces.",
    category: "event-centre",
    city: "lagos",
    location: "Online Directory",
    price: "Free",
    priceType: "per-event",
    imageUrl: "https://images.unsplash.com/photo-1505236858219-8359eb29e329?w=800&q=80",
    tourUrl: "https://example.com/berlin-event-locations",
    amenities: ["Multiple Venues", "360° Tour Badges", "Search by Capacity", "Venue Filters"],
    rating: 4.6,
    reviewCount: 22,
    featured: false,
    verified: false,
    captureDate: "2025-10-20",
  },
  {
    id: "14",
    slug: "lapentor-dsc-library",
    title: "Lapentor DSC Library Tour",
    description: "Multi-room library tour with classrooms and hallways — perfect for educational space showcases.",
    category: "office",
    city: "jos",
    location: "Digital Scholarship Commons",
    price: "Free",
    priceType: "per-event",
    imageUrl: "https://images.unsplash.com/photo-1579370318445-a9f0f3ade070?w=800&q=80",
    tourUrl: "https://app.lapentor.com/sphere/digital-scholarship-commons-dsc",
    amenities: ["Multi-Room Tour", "Classrooms", "Study Spaces", "Accessible"],
    rating: 4.7,
    reviewCount: 34,
    featured: false,
    verified: false,
    captureDate: "2024-12-05",
  },
  {
    id: "15",
    slug: "dsc-3d-printers-offices",
    title: "DSC 3D Printers & Offices",
    description: "A small commercial space demo with equipment—best for showing how to present workshop and maker spaces.",
    category: "office",
    city: "lagos",
    location: "Sample Workshop",
    price: "Contact",
    priceType: "per-event",
    imageUrl: "https://images.unsplash.com/photo-1545239351-1141bd82e8a6?w=800&q=80",
    tourUrl: "https://example.com/dsc-3d-printers-and-offices",
    amenities: ["Workshop", "Equipment", "Flexible Layout", "Video Demo"],
    rating: 4.5,
    reviewCount: 16,
    featured: false,
    verified: false,
    captureDate: "2025-08-12",
  },
  {
    id: "3",
    slug: "royal-gardens-hotel-maitama",
    title: "Royal Gardens Hotel",
    description: "Experience luxury at Royal Gardens Hotel. Our premium suites offer breathtaking city views, world-class amenities, and impeccable service in the exclusive Maitama district.",
    category: "hotel",
    city: "abuja",
    location: "Maitama, Abuja",
    price: "₦75,000",
    priceType: "per-night",
    imageUrl: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80",
    tourUrl: TOUR_URLS.hotel1,
    amenities: ["Pool", "Gym", "Restaurant", "Spa", "Room Service", "Conference Rooms"],
    rating: 4.8,
    reviewCount: 312,
    featured: true,
    capacity: "150 rooms",
    size: "45 sqm per room",
    coordinates: { lat: 9.0826, lng: 7.4934 },
    beaconNumber: "FCT/ABJ/MT/2024/0127",
    verified: true,
    captureDate: "2026-01-20",
    galleryImages: [
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80",
      "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=800&q=80",
      "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800&q=80",
    ],
  },
  {
    id: "4",
    slug: "skyline-serviced-apartments-wuse",
    title: "Skyline Serviced Apartments",
    description: "Modern furnished apartments with panoramic views of Abuja. Ideal for business executives and diplomats seeking comfort and convenience in Wuse 2.",
    category: "apartment",
    city: "abuja",
    location: "Wuse 2, Abuja",
    price: "₦450,000",
    priceType: "per-month",
    imageUrl: "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=800&q=80",
    tourUrl: TOUR_URLS.apartment1,
    amenities: ["Furnished", "Security", "Gym", "Parking", "Generator", "High-Speed WiFi"],
    rating: 4.7,
    reviewCount: 89,
    featured: true,
    capacity: "3 Bedrooms",
    size: "180 sqm",
    coordinates: { lat: 9.0765, lng: 7.4898 },
    beaconNumber: "FCT/ABJ/WS/2024/0893",
    verified: true,
    captureDate: "2026-02-01",
    galleryImages: [
      "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=800&q=80",
      "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&q=80",
      "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800&q=80",
    ],
  },
  {
    id: "5",
    slug: "grand-ballroom-garki",
    title: "Grand Ballroom Garki",
    description: "The most prestigious event venue in Garki. Our grand ballroom has hosted dignitaries, celebrities, and unforgettable moments for over a decade.",
    category: "event-centre",
    city: "abuja",
    location: "Garki Area 3, Abuja",
    price: "₦1,200,000",
    priceType: "per-event",
    imageUrl: "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=800&q=80",
    tourUrl: TOUR_URLS.eventCentre2,
    amenities: ["1000 Capacity", "Valet Parking", "Red Carpet", "VIP Lounge", "LED Screens", "Professional Lighting"],
    rating: 5.0,
    reviewCount: 203,
    featured: true,
    capacity: "1,000 guests",
    size: "5,000 sqm",
    coordinates: { lat: 9.0512, lng: 7.4889 },
    beaconNumber: "FCT/ABJ/GK/2024/0312",
    verified: true,
    captureDate: "2025-12-10"
  },
  {
    id: "6",
    slug: "harbour-point-victoria-island",
    title: "Harbour Point Victoria Island",
    description: "Lagos' premier waterfront event space. Stunning ocean views meet sophisticated design for events that leave lasting impressions.",
    category: "event-centre",
    city: "lagos",
    location: "Victoria Island, Lagos",
    price: "₦2,500,000",
    priceType: "per-event",
    imageUrl: "https://images.unsplash.com/photo-1431540015161-0bf868a2d407?w=800&q=80",
    tourUrl: TOUR_URLS.eventCentre1,
    amenities: ["Ocean View", "800 Capacity", "Helipad", "VIP Jetty", "Fine Dining", "Event Planning"],
    rating: 4.9,
    reviewCount: 156,
    featured: false,
    capacity: "800 guests",
    size: "3,500 sqm",
    coordinates: { lat: 6.4281, lng: 3.4219 },
    verified: true,
    captureDate: "2026-01-25"
  },
  {
    id: "7",
    slug: "plaza-continental-hotel-ikoyi",
    title: "Plaza Continental Hotel",
    description: "Five-star luxury in the heart of Lagos. Where business meets pleasure with world-class facilities and Nigerian hospitality.",
    category: "hotel",
    city: "lagos",
    location: "Ikoyi, Lagos",
    price: "₦125,000",
    priceType: "per-night",
    imageUrl: "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=800&q=80",
    tourUrl: TOUR_URLS.hotel2,
    amenities: ["Infinity Pool", "Rooftop Bar", "Business Centre", "Concierge", "Airport Shuttle", "Tennis Court"],
    rating: 4.8,
    reviewCount: 445,
    featured: false,
    capacity: "200 rooms",
    size: "55 sqm per room",
    coordinates: { lat: 6.4474, lng: 3.4345 },
    verified: true,
    captureDate: "2026-02-05"
  },
  {
    id: "8",
    slug: "jos-heritage-resort",
    title: "Jos Heritage Resort",
    description: "Escape to the cool climate of Jos Plateau. Our heritage resort combines colonial architecture with modern comforts for a unique retreat.",
    category: "hotel",
    city: "jos",
    location: "Rayfield, Jos",
    price: "₦45,000",
    priceType: "per-night",
    imageUrl: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800&q=80",
    tourUrl: TOUR_URLS.hotel3,
    amenities: ["Mountain View", "Garden", "Fireplace", "Restaurant", "Tour Guides", "WiFi"],
    rating: 4.6,
    reviewCount: 78,
    featured: false,
    capacity: "40 rooms",
    size: "35 sqm per room",
    coordinates: { lat: 9.9167, lng: 8.8500 },
    verified: true,
    captureDate: "2026-01-30"
  },
  {
    id: "9",
    slug: "executive-towers-office-cbd",
    title: "Executive Towers Office",
    description: "Premium Grade A office space in Abuja's central business district. Modern facilities designed for multinational corporations and growing businesses.",
    category: "office",
    city: "abuja",
    location: "Central Business District, Abuja",
    price: "₦8,500,000",
    priceType: "per-month",
    imageUrl: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80",
    tourUrl: TOUR_URLS.office1,
    amenities: ["Reception", "Meeting Rooms", "Cafeteria", "24/7 Security", "Elevator", "Backup Power"],
    rating: 4.7,
    reviewCount: 34,
    featured: false,
    capacity: "Open Plan",
    size: "1,200 sqm",
    coordinates: { lat: 9.0580, lng: 7.4900 },
    beaconNumber: "FCT/ABJ/CBD/2024/0067",
    verified: true,
    captureDate: "2026-02-10"
  },
  {
    id: "10",
    slug: "the-terrace-restaurant-asokoro",
    title: "The Terrace Restaurant",
    description: "Fine dining with a view. Our rooftop terrace serves continental and Nigerian cuisine in an atmosphere of refined elegance.",
    category: "restaurant",
    city: "abuja",
    location: "Asokoro, Abuja",
    price: "₦350,000",
    priceType: "per-event",
    imageUrl: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&q=80",
    tourUrl: TOUR_URLS.restaurant1,
    amenities: ["Private Dining", "City View", "Wine Cellar", "Live Music", "Valet", "Chef's Table"],
    rating: 4.9,
    reviewCount: 267,
    featured: false,
    capacity: "120 guests",
    size: "450 sqm",
    coordinates: { lat: 9.0453, lng: 7.5134 },
    verified: true,
    captureDate: "2025-11-20"
  },
  {
    id: "11",
    slug: "marina-residences-lekki",
    title: "Marina Residences",
    description: "Luxury waterfront living in Lagos. Wake up to stunning lagoon views in these fully furnished executive apartments.",
    category: "apartment",
    city: "lagos",
    location: "Lekki Phase 1, Lagos",
    price: "₦1,200,000",
    priceType: "per-month",
    imageUrl: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&q=80",
    tourUrl: TOUR_URLS.apartment2,
    amenities: ["Waterfront", "Smart Home", "Pool", "Gym", "Concierge", "Boat Dock"],
    rating: 4.8,
    reviewCount: 56,
    featured: false,
    capacity: "4 Bedrooms",
    size: "320 sqm",
    coordinates: { lat: 6.4353, lng: 3.4750 },
    verified: true,
    captureDate: "2026-02-08"
  }
];

export const cities = [
  { value: 'all', label: 'All Cities', count: sampleListings.length },
  { value: 'abuja', label: 'Abuja', count: sampleListings.filter(l => l.city === 'abuja').length },
  { value: 'lagos', label: 'Lagos', count: sampleListings.filter(l => l.city === 'lagos').length },
  { value: 'jos', label: 'Jos', count: sampleListings.filter(l => l.city === 'jos').length },
  { value: 'port-harcourt', label: 'Port Harcourt', count: sampleListings.filter(l => l.city === 'port-harcourt').length },
];

export const LIVE_TOUR_SLUGS = sampleListings.filter((listing) => listing.isLive).map((listing) => listing.slug);

export const isLiveListing = (listing: PropertyListing) => Boolean(listing.isLive);

export const categories = [
  { value: 'all', label: 'All Types', icon: '🏢' },
  { value: 'event-centre', label: 'Event Centres', icon: '🎉' },
  { value: 'hotel', label: 'Hotels', icon: '🏨' },
  { value: 'apartment', label: 'Apartments', icon: '🏠' },
  { value: 'office', label: 'Offices', icon: '💼' },
  { value: 'restaurant', label: 'Restaurants', icon: '🍽️' },
];

export const pricingPlans = [
  {
    id: 'starter',
    name: 'Starter',
    price: '₦75,000',
    period: 'per property',
    description: 'Perfect for single property owners wanting to showcase their space',
    features: [
      '1 Property Tour',
      'Basic 360° Capture',
      'WhatsApp Booking Link',
      'Mobile Optimized',
      '3 Month Hosting',
      'Basic Analytics',
    ],
    highlighted: false,
    cta: 'Get Started',
  },
  {
    id: 'professional',
    name: 'Professional',
    price: '₦150,000',
    period: 'per property',
    description: 'Ideal for hotels and event centres seeking premium presentation',
    features: [
      'Up to 3 Property Tours',
      'Premium 360° Capture',
      'Custom Branding',
      'Priority WhatsApp Support',
      '12 Month Hosting',
      'Advanced Analytics',
      'Social Media Assets',
      'Featured on Vista360 TV',
    ],
    highlighted: true,
    cta: 'Most Popular',
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    price: 'Custom',
    period: 'contact for pricing',
    description: 'For property managers and real estate portfolios',
    features: [
      'Unlimited Property Tours',
      'Cinematic 360° Capture',
      'White-Label Solution',
      'API Integration',
      'Dedicated Account Manager',
      'Custom Analytics Dashboard',
      'Lead Generation Tools',
      'Exclusive Vista360 TV Series',
    ],
    highlighted: false,
    cta: 'Contact Sales',
  },
];

export const tvEpisodes = [
  {
    id: '1',
    title: 'Inside Abuja\'s Most Luxurious Event Centres',
    description: 'Take a virtual journey through the top 5 event venues in Garki and Maitama.',
    thumbnail: 'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?w=800&q=80',
    duration: '12:45',
    views: 15420,
    date: '2024-01-15',
    category: 'Event Centres',
  },
  {
    id: '2',
    title: 'Hotel Suite Tour: Royal Gardens Maitama',
    description: 'Experience the presidential suite like never before with our immersive 360° tour.',
    thumbnail: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80',
    duration: '8:32',
    views: 8930,
    date: '2024-01-08',
    category: 'Hotels',
  },
  {
    id: '3',
    title: 'Apartment Hunting in Wuse 2: A Virtual Guide',
    description: 'Compare 5 premium serviced apartments without leaving your home.',
    thumbnail: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=800&q=80',
    duration: '15:20',
    views: 12100,
    date: '2024-01-01',
    category: 'Apartments',
  },
  {
    id: '4',
    title: 'Wedding Venue Showdown: Lagos vs Abuja',
    description: 'Which city has the best wedding venues? We explore 10 stunning locations.',
    thumbnail: 'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=800&q=80',
    duration: '18:55',
    views: 23500,
    date: '2023-12-20',
    category: 'Event Centres',
  },
  {
    id: '5',
    title: 'The Rise of Virtual Tours in Nigeria',
    description: 'How Vista360 is transforming property marketing across the country.',
    thumbnail: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80',
    duration: '10:15',
    views: 5670,
    date: '2023-12-15',
    category: 'Industry',
  },
];

export const WHATSAPP_NUMBER = '2349120772775';

export const getWhatsAppLink = (message: string) => {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
};
